import { useState, useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@app/store";
import { setBlogs, useDeleteBlogMutation, useLazyGetBlogsQuery } from "@modules/blog";
import { FilterParams } from "types";
import { PARAMS } from "@constants/index";
import { useUpdateVisibalityInHomeMutation } from "@modules/blog/api/blog.api";
import { IBlog } from "@modules/blog/types";
import { toast } from 'react-toastify';

export const useBlogsLogic = () => {
  const dispatch = useAppDispatch();
  const blogsList = useAppSelector((state) => state.blog.blogs)
  const [updateVisibalityInHome] = useUpdateVisibalityInHomeMutation()

  const [getBlogs] = useLazyGetBlogsQuery()
  const [deleteBlog] = useDeleteBlogMutation()
  const [pagesCount, setPagesCount] = useState<number>(1);
  const [filters, setFilters] = useState<FilterParams>({
    limit: PARAMS.LIMIT,
    offset: PARAMS.OFFSET,
  })

  const handleGetRequest = async () => {
    try {
      const responseBlogs = await getBlogs(filters).unwrap();

      dispatch(setBlogs(responseBlogs.blogs));
      setPagesCount(responseBlogs.count || 1)
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteBlog = async (id?: string) => {
    if (!id) {
      return null
    }

    try {
      await deleteBlog({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  const handlePagination = (page: number, limit: number) => {
    const offset = page === 1 ? PARAMS.OFFSET : limit * (page - 1)

    setFilters({ limit, offset })
  }

  const handleChange = (blog: IBlog) => {
    if (!blog?.id) {
      return
    }

    const alternativeValue = !blog.activeInHome;

    updateVisibalityInHome({
      id: blog.id,
      activeInHome: alternativeValue
    })
      .unwrap()
      .then(() => {
        const updated = blogsList?.map((item) => {
          if (item.id === blog?.id) {
            return { ...item, activeInHome: alternativeValue }
          }

          return item
        })

        dispatch(setBlogs(updated));
      })
      .catch((error) => {
        if (error?.data?.message) {
          toast(error?.data?.message, { type: 'warning' })

          return
        }

        console.log(error);
      })
  }

  useEffect(() => {
    handleGetRequest()
  }, [filters])

  return {
    blogsList,
    handleChange,
    handleDeleteBlog,
    pagesCount,
    handlePagination
  };
}
